import { useNavigate } from 'react-router-dom';
import styles from './SlideShell.module.css';

export default function SlideShell({ handleNext, handlePrev, current, total, children, t }) {
  const navigate = useNavigate();
  const isLastChapter = current === total - 1;

  const handleNaviagteHome = () => {
    sessionStorage.setItem('hasSeenOnboarding', 'true');
    navigate('/', { replace: true });
  };

  return (
    <div className={styles.shell}>
      <div className={styles.skipWrapper}>
        <button className={styles.skipBtn} onClick={handleNaviagteHome}>{t("skip")}</button>
      </div>
      <div className={styles.content}>
        {children}
      </div>
      <div className={styles.nav}>
        <button className={styles.prevBtn} onClick={handlePrev} disabled={current === 0}>
          <img src="/assets/intro/prev.svg" alt="" width={11}  height={11}/>
          {t("previous")}
        </button>
        <button className={styles.nextBtn} onClick={isLastChapter ? handleNaviagteHome : handleNext}>
          {isLastChapter ? t("lets_start") : t("next")}
          <img 
            src={isLastChapter ? "/assets/intro/congrats.svg" : "/assets/intro/next.svg"} 
            alt="" 
            width={isLastChapter ? 18 : 11} 
            height={isLastChapter ? 18 : 11}
          />
        </button>
      </div>
    </div>
  );
}